module.exports = __webpack_public_path__ + "static/media/iot.fb4f7afd.jpg";